import { Component, OnInit, Input } from '@angular/core';
import { E5coreUiSearchFormBaseComponent } from './e5core-ui-search-form-base';

@Component({
  selector: 'e5core-ui-search-form-material',
  templateUrl: './e5core-ui-search-form-material.component.html',
  styleUrls: ['./e5core-ui-search-form-material.component.css']
})
export class E5coreUiSearchFormMaterialComponent extends E5coreUiSearchFormBaseComponent implements OnInit {

  ngOnInit() {
  }

}
